<h1>Main Page</h1>

<!-- <button (click)="goToHome()">
  Go to Home Page
</button>

<button routerLink="/webpage">
  Go to Web Page
</button> -->
